<div class="flex a-center j-space-between mrb-1">
    <div>
        <button *ngIf="config.withCheckboxes" [disabled]="selection.isEmpty()" [matMenuTriggerFor]="bulkActions" mat-stroked-button>
            <mat-icon>settings</mat-icon>
            Выбрать действие
        </button>
        <mat-menu #bulkActions="matMenu" xPosition="before">
            <div class="flex-column">
                <button (click)="bulkEdit(RowAction.DELETE)" class="flex j-start" color="primary" mat-button>
                    Удалить
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </mat-menu>
    </div>

    <div>
        <button [matMenuTriggerFor]="toggleCols" mat-stroked-button>
            <mat-icon>view_week</mat-icon>
            Изменить столбцы
        </button>
        <mat-menu #toggleCols="matMenu" xPosition="before">
            <div class="flex-column">
                <ng-container *ngFor="let col of config.columns">
                    <button
                        (click)="toggleCol(col.name); $event.stopPropagation()"
                        *ngIf="!col.hidden"
                        class="flex j-start"
                        color="primary"
                        mat-button
                    >
                        <mat-icon>{{ displayedColumns.includes(col.name) ? 'done' : 'close' }}done</mat-icon>
                        <span>{{ col.title }}</span>
                    </button>
                </ng-container>
            </div>
        </mat-menu>

        @if (config.showCreateButton) {
            <button mat-flat-button class="mrl-1" color="primary" (click)="processAction(rowActions.CREATE, [])" data-testid="add-item-button">
                {{ config.createButtonLabel }}
            </button>
        }
    </div>
</div>

<div *ngIf="config" class="table">
    <mat-table
        (cdkDropListDropped)="drop($event)"
        (matSortChange)="onSortChange($event)"
        [dataSource]="dataSource"
        cdkDropList
        cdkDropListOrientation="horizontal"
        matSort
    >
        <ng-container *ngIf="config.withCheckboxes" [matColumnDef]="checkboxColumnName">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                ></mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" mat-cell>
                <mat-checkbox
                    (change)="$event ? selection.toggle(element) : null"
                    (click)="$event.stopPropagation()"
                    [checked]="selection.isSelected(element)"
                ></mat-checkbox>
            </mat-cell>
        </ng-container>

        @if (config.actionsMenu) {
            <ng-container [matColumnDef]="'menuActions'">
                <th mat-header-cell *matHeaderCellDef aria-label="menu" class="pd-0">
                    <span class="pdr-5"></span>
                </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="more">
                        <mat-icon class="tx-primary">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        @for (action of config.actionsMenu; track $index) {
                            <button (click)="processAction(action, element)" mat-menu-item>
                                <mat-icon class="material-icons-outlined">{{ action }}</mat-icon>
                                <span class="t-capitalize">{{ action }}</span>
                            </button>
                        }
                    </mat-menu>
                </td>
            </ng-container>
        }

        <ng-container *ngFor="let col of config.columns" [matColumnDef]="col.name">
            <mat-header-cell
                *matHeaderCellDef
                [disabled]="!col.withSort"
                [style.display]="col.hidden ? 'none' : ''"
                cdkDrag
                mat-sort-header
            >
                {{ col.title }}
            </mat-header-cell>

            <mat-cell
                *matCellDef="let element"
                [attr.data-label]="col.title"
                [style.display]="col.hidden ? 'none' : ''"
                class="t-ellipsis p-relative"
                [appCustomTooltip]="col.showToolTip ? element[col.name] : ''"
            >
                <ng-container *ngIf="dataIsBoolean(element[col.name]); else otherData">
                    <mat-icon>
                        {{ element[col.name] ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                </ng-container>

                <ng-template #otherData>
                    @if (!col.type) {
                        @if (element[col.name] && findLink(element[col.name])) {
                            <a [href]="findLink(element[col.name])" class="mrr-0-3" target="_blank" (click)="$event.stopPropagation()">
                                <mat-icon>link</mat-icon>
                            </a>
                        }

                        {{ element[col.name] }}
                    }

                    @if (col.type === Date) {
                        {{ element[col.name] | date: 'dd/MM/yy' }}
                    }

                    @if (col.type === 'metadata') {
                        {{ element[col.name] ? JSON.stringify(element[col.name]) : null }}
                    }

                    @if (col.type === 'DateTime') {
                        {{ element[col.name] | date: 'dd.MM.yyyy, HH:mm:ss:SSS' : '+03:00' }}
                    }

                    @if (col.type === 'copy' && element[col.name]) {
                        <button
                            mat-icon-button
                            color="primary"
                            class="copy-btn mrr-0-3"
                            (click)="copyToClipboard($event, element[col.name])"
                        >
                            <mat-icon id="copy-icon">content_copy</mat-icon>
                        </button>
                        {{ element[col.name] }}
                    }

                    @if (col.type === 'search') {
                        <button
                            mat-icon-button
                            color="primary"
                            class="copy-btn mrr-0-3"
                            (click)="autocompleteFilter(element[col.name], col.name)"
                        >
                            <mat-icon>search</mat-icon>
                        </button>
                        {{ element[col.name] }}
                    }

                    @if (col.type === 'audio') {
                        <figure>
                            <audio controls>
                                <source [src]="element[col.name]" type="audio/mpeg" />
                            </audio>
                        </figure>
                        {{ element[col.name] }}
                    }
                </ng-template>
            </mat-cell>
        </ng-container>

        <tr *matNoDataRow class="pd-1">
            <td [colSpan]="displayedColumns.length">Нет данных</td>
        </tr>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row
            (click)="processAction(rowActions.CLICK, [row])"
            *matRowDef="let row; columns: displayedColumns"
            class="cursor-pointer"
        ></mat-row>
    </mat-table>
    <!-- todo hide if there is only one page-->
    <mat-paginator
        (page)="onChangePage()"
        *ngIf="config.paginatorConfig"
        [length]="config.paginatorConfig.totalItems"
        [pageSizeOptions]="[5, 10, 30, 100, 500]"
        [pageSize]="config.paginatorConfig.itemsPerPage"
        showFirstLastButtons="true"
    ></mat-paginator>
</div>
